import { AssetsHost } from "@coeff/utils";
import { COLORS, LOGO_SIZE } from "@coeff/utils";
import { Layout } from "antd";
import * as React from "react";
import styled from "styled-components";

import { sentryCapture } from "../utils";

import { CenterAlign } from "./CenterAlign";
import { DEPRECATED_Button } from "./DEPRECATED_Button";
import { CoeLogo } from "./Icons";

const { Content, Header } = Layout;

const StyledContent = styled(Content)`
  && {
    height: 100%;
    background-color: ${COLORS.white};

    .title {
      color: ${COLORS.black85};
      padding: 10px 15px;
      margin-bottom: 0px;
    }
  }
`;

const EmptyGraphicsWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const StyledButton = styled(DEPRECATED_Button)`
  && {
    line-height: 2;
    width: 200px;
  }
`;

const defaultState = { error: null, errorInfo: null };

interface Props {
  children: React.ReactChild;
  onBack: () => void;
}

interface State {
  error: any;
  errorInfo: React.ErrorInfo | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = defaultState;
  }

  componentDidCatch = (error: any, errorInfo: React.ErrorInfo) => {
    sentryCapture({
      error,
      name: "ErrorBoundary",
      context: { errorInfo },
    });

    this.setState({ error, errorInfo });
  };

  handleClick = () => {
    const { onBack } = this.props;

    this.resetError();

    return onBack();
  };

  resetError = () => this.setState(defaultState);

  render = () => {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <CenterAlign>
          <EmptyGraphicsWrap>
            <h3 className="title">Oops, something went wrong.</h3>

            <p
              style={{
                margin: "0 30px 30px",
                textAlign: "center",
                color: COLORS.black45,
              }}
            >
              The team has been notified. If the issue persists, let us know and we'll investigate
              right away. <a href="mailto:help@coefficient.io">help@coefficient.io</a>
            </p>

            <StyledButton onClick={this.handleClick} type="primary">
              <div>Back to Home</div>
            </StyledButton>
          </EmptyGraphicsWrap>
        </CenterAlign>
      );
    }

    return children;
  };
}
